import { Component, OnInit, Input } from '@angular/core';
import { DynamicHeaderService } from 'projects/standard-team/src/app/service/dynamic-header.service';

@Component({
	selector: 'app-common-headers',
	templateUrl: './common-headers.component.html',
	styleUrls: ['./common-headers.component.css']
})
export class CommonHeadersComponent implements OnInit {
	// tslint:disable-next-line:no-input-rename
	@Input('initial') initial = { icon: '', a: '', b: '' };
	constructor(
		private _dynamicHeaderService: DynamicHeaderService
	) { }

	ngOnInit() {
		this.initial = this._dynamicHeaderService.data;
		this._dynamicHeaderService.getDynamicHeader().subscribe(
			header => {
				this.initial = header;
				console.log('---------------S-S-S---------------------------', this.initial);
			}
		);
		// if (this.initial) {
		// 	this.data = undefined;
		// }
		// console.log(this.data);

	}

}
